import { Component, OnInit, Input } from '@angular/core';
import { CardToken, CardTokenService, ProviderName } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTime } from 'luxon';

@Component({
  selector: 'fgbcl-card-token',
  templateUrl: './card-token.component.html',
  styleUrls: ['./card-token.component.scss'],
})
export class CardTokenComponent implements OnInit {
  @Input() cardToken!: CardToken;
  @Input() cardIssuerProvider: string = '';
  @Input() showExpiry: boolean = false;
  showBack: boolean = false;

  constructor(
    private cardTokenService: CardTokenService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {}

  setCardAsDefault() {
    this.cardTokenService.setCardAsDefault(this.cardToken.TokenId);
    this.close();
  }

  switchCardSide() {
    this.showBack = !this.showBack;
  }

  cardIsInactive(): boolean {
    return !this.cardToken.IsDefaultToken;
  }

  cardIsActive(): boolean {
    return this.cardToken.IsDefaultToken && !this.cardToken.Frozen;
  }

  cardIsFrozen(): boolean {
    return this.cardToken.Frozen && this.cardToken.IsDefaultToken;
  }

  cardIsExpire(): boolean {
    if (this.noExpiry) {
      return false;
    }
    const expiry = DateTime.fromISO(this.cardToken?.ExpiryDate as string, { zone: 'utc' });
    const current = DateTime.utc();
    const now = expiry.diff(current, 'minutes').minutes;
    if (now < 0) {
      return true;
    } else {
      return false;
    }
  }

  freezeCard() {
    this.cardTokenService.setCardTokenFrozenState(this.cardToken.TokenId, true);
    this.close();
  }

  unfreezeCard() {
    this.cardTokenService.setCardTokenFrozenState(this.cardToken.TokenId, false);
    this.close();
  }

  deleteCard() {
    this.cardTokenService.deleteCardToken(this.cardToken.TokenId);
    this.close();
  }

  close() {
    this.modalService.dismissAll();
  }

  get noExpiry(): boolean {
    return [ProviderName.PayPal, ProviderName.Paze].includes(this.cardToken.ProviderId);
  }

  isPaze(): boolean {
    return this.cardToken.ProviderId === ProviderName.Paze;
  }

  isPayPal(): boolean {
    return this.cardToken.ProviderId === ProviderName.PayPal;
  }
}
